function initFloorplans(block) {
    if (block.dataset.p7FloorPlansInit) return;
    block.dataset.p7FloorPlansInit = '1';

    const gridContainer = block.querySelector('.p7-floorplans');
    const loadMoreBtn = block.querySelector('.p7-load-more');
    const loadingEl = block.querySelector('.p7-loading');
    const filters = block.querySelectorAll('.p7-filter');
    const resetBtn = block.querySelector('.p7-reset-filters');
    const pagination = block.querySelector('.p7-floorplan-pagination');
    let skeletonShown = false;
    // const countElement  = block.querySelector('.p7-inventory-count');

    const attributes = JSON.parse(block.dataset.attributes || '{}');
    const ajaxurl = block.dataset.ajaxurl;
    // const nonce = block.dataset.nonce;

    let currentPage = 1;
    let maxPages = 1;
    let isLoading = false;
    let currentFilters = {};

    function serializeFilters() {
        const obj = {};
        filters.forEach(f => {
            if (f.type === 'checkbox') {
                if (!obj[f.name]) obj[f.name] = [];
                if (f.checked) obj[f.name].push(f.value);
            } else {
                if (f.value !== undefined && f.value !== '') {
                    obj[f.name] = f.value;
                }
            }
        });
        return obj;
    }

    function loadFloorplans(page = 1, filters = {}) {
        if (isLoading) return;
        isLoading = true;
        currentPage = page;

        // Show loading spinner and hide grid
        if (page === 1 && !skeletonShown) {
            loadingEl.style.display = 'flex';
        }
        if (page === 1) {
            if (gridContainer) {
                gridContainer.style.opacity = '0';
                gridContainer.style.pointerEvents = 'none';
                gridContainer.style.display = 'none';
                gridContainer.innerHTML = '';
            }

            if (pagination) pagination.style.display = "none";
        }
        if (page === 1) gridContainer.innerHTML = '';

        const body = new URLSearchParams({
            action: 'p7_load_floorplans',
            page: page.toString(),
            attributes: JSON.stringify(attributes),
            filters: JSON.stringify(filters)
        });

        fetch(ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString()
        })
            .then(r => r.json())
            .then(data => {
                if (data.success) {
                    if (page === 1) {
                        gridContainer.innerHTML = data.data.html;
                    } else {
                        gridContainer.insertAdjacentHTML('beforeend', data.data.html);
                    }

                    if (block.dataset.skeletonShown === '0') {
                        block.dataset.skeletonShown = '1';
                    }

                    // countElement && (countElement.textContent = `Showing ${data.data.showing} of ${data.data.total_found} results`);

                    maxPages = data.data.max_pages;
                    currentPage = data.data.current_page;

                    if (loadMoreBtn) {
                        loadMoreBtn.style.display = (currentPage < maxPages) ? 'flex' : 'none';
                    }
                } else {
                    console.error('Load homes error', data);
                }
            })
            .catch(err => console.error('AJAX Error:', err))
            .finally(() => {
                // Random delay between 3s and 5s
                setTimeout(() => {
                    isLoading = false;
                    if (loadingEl && page === 1 && !skeletonShown) {
                        loadingEl.style.display = 'none';
                        skeletonShown = true;
                    }
                    if (gridContainer) {
                        gridContainer.style.opacity = '1';
                        gridContainer.style.pointerEvents = 'auto';
                        if (gridContainer) {
                            gridContainer.style.display = 'grid';
                            gridContainer.style.opacity = '1';
                            gridContainer.style.pointerEvents = 'auto';
                        }
                        if (maxPages > 1) {
                            pagination.style.display = "flex";
                        } else {
                            pagination.style.display = "none";
                        }
                    }

                    if (typeof AOS !== "undefined") {
                        requestAnimationFrame(() => {
                            AOS.refreshHard();
                        });
                    }

                }, 100);

            });
    }

    function applyFilters() {
        currentFilters = serializeFilters();
        loadFloorplans(1, currentFilters);
    }

    function resetFilters() {
        filters.forEach(f => {
            if (f.type === 'checkbox' || f.type === 'radio') f.checked = false;
            else f.value = '';
        });
        currentFilters = {};
        loadFloorplans(1, {});
    }

    loadFloorplans();
    loadMoreBtn?.addEventListener('click', () => loadFloorplans(currentPage + 1, currentFilters));
    filters.forEach(f => f.addEventListener('change', applyFilters));
    resetBtn?.addEventListener('click', resetFilters);
}

// MutationObserver to initialize new blocks dynamically
const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
        m.addedNodes.forEach(node => {
            if (!(node instanceof Element)) return;
            if (node.classList.contains('p7-floorplans-block')) {
                initFloorplans(node);
            }
            node.querySelectorAll('.p7-floorplans-block').forEach(initFloorplans);
        });
    });
});

if (document.body instanceof Element) {
    observer.observe(document.body, { childList: true, subtree: true });
}

// Initialize existing blocks on page load
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.p7-floorplans-block').forEach(initFloorplans);
});

// Share popup functionality
// Share popup functionality
document.addEventListener("click", function (e) {

    const btn = e.target.closest(".floorplans-share");
    if (!btn) return;

    const title = encodeURIComponent(btn.dataset.title || "");
    const url = btn.dataset.url || "";
    const encodedUrl = encodeURIComponent(url);

    const popup = document.querySelector("#floorplan-share-popup");
    if (!popup) return;

    // Email
    const emailLink = popup.querySelector(".share-email");
    if (emailLink) {
        emailLink.href =
            `mailto:?subject=${title}&body=${encodedUrl}`;
    }

    // Facebook
    const fbLink = popup.querySelector(".share-facebook");
    if (fbLink) {
        fbLink.href =
            `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    }

    // Copy link
    const copyBtn = popup.querySelector(".copy-link-btn");

    if (copyBtn && !copyBtn.dataset.bound) {
        copyBtn.dataset.bound = "true";
        // preserve svg icon
        if (!copyBtn.querySelector(".copy-text")) {
            const textNode = document.createElement("span");
            textNode.className = "copy-text";
            textNode.textContent = "Copy Link";
            const svg = copyBtn.querySelector("svg");
            copyBtn.innerHTML = "";
            if (svg) copyBtn.appendChild(svg);
            copyBtn.appendChild(textNode);
        }

        const textEl = copyBtn.querySelector(".copy-text");

        copyBtn.addEventListener("click", async () => {

            try {
                await navigator.clipboard.writeText(url);
                const original = textEl.textContent;
                textEl.textContent = "Copied!";
                setTimeout(() => {
                    textEl.textContent = original;
                }, 2000);
            } catch (err) {
                console.log("Copy failed", err);
            }
        });
    }

});


document.addEventListener('click', function (e) {

    const btn = e.target.closest('.tour-floorplans.btn-scendery');
    if (!btn) return;

    const href = btn.getAttribute('href');

    if (!href || !href.startsWith('#')) return;

    e.preventDefault();

    const anchor = href.replace('#', '');

    const popupWrapper = document.querySelector(
        `.guten-popup-builder[data-anchor="${anchor}"]`
    );

    const popup = popupWrapper?.querySelector('.guten-popup');

    if (popup) {
        popup.classList.add('show');
    }

    // populate Gravity Forms fields
    setTimeout(() => {

        const plan = btn.dataset.plan || '';
        const community = btn.dataset.community || '';

        const communityField = popupWrapper.querySelector('#input_9_6');
        const planField = popupWrapper.querySelector('#input_9_7');

        if (communityField) communityField.value = community;
        if (planField) planField.value = plan;

    }, 300);

});